import Modal from 'components/ModalContainer'
import { buildTranslate } from 'locales'
import React from 'react'

const t = buildTranslate('insights_lab_v2')

type Props = {
  favoriteName: string
  isOpen: boolean
  isRemoving?: boolean
  onClose: () => void
  onRemove: () => void
}

// Confirms before removing a saved favorite from the open-tab star (the
// picker's own favorites list uses a different, inline confirmation —
// see FavoriteRow — this is specifically for the in-workspace tab star).
const RemoveFavoriteModal: React.FC<Props> = ({
  favoriteName,
  isOpen,
  isRemoving = false,
  onClose,
  onRemove,
}) => (
  <Modal
    isLoading={isRemoving}
    title={t('remove_favorite_modal.title')}
    subtitle={t('remove_favorite_modal.description', { name: favoriteName })}
    proceedText={t('remove_favorite_modal.cta')}
    isOpen={isOpen}
    onClose={onClose}
    onProceed={onRemove}
    canProceed
  />
)

export default RemoveFavoriteModal
